(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-purchase-assurance"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-sbz-restock]').forEach((root) => {
    if (root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';
    const toggle = root.querySelector('[data-sbz-restock-toggle]');
    const panel = root.querySelector('[data-sbz-restock-panel]');
    if (!toggle || !panel) return;
    const setOpen = (open) => {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
    };
    toggle.addEventListener('click', () => {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });
    if (root.dataset.shouldOpen === 'true') setOpen(true);
  });
  } catch(e) { console.error(e); }
})();

})();
